import { AuthenticationDetails } from 'amazon-cognito-identity-js';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import userPool from '../../../utils/userPool';
import { CurrentPassword } from './currentPassword';
import { NewPassword } from './NewPassword';

interface Props {
  submenuTab: string;
  onBack: () => void;
}

const PasswordManager: React.FC<Props> = ({ submenuTab, onBack }) => {
  const [currentStep, setCurrentStep] = useState<string>('currentPassword');
  const [oldPassword, setOldPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [validationErrors, setValidationErrors] = useState<{ currentPassword?: string; newPassword?: string }>({});
  const [message, setMessage] = useState<string>('');
  const [errors, setErrors] = useState<{ [key: string]: string }>({}); // For cognito errors    
  const [newPassword, setNewPassword] = useState<string>('');
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [, setValidationResults] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleCancel = () => {
    setOldPassword('');
    setNewPassword('');
    setCurrentStep('currentPassword');
  };
  
  const handleFormSubmit = (formData: { currentPassword: string }) => {
    setIsLoading(true);
  
    const user = userPool.getCurrentUser();
    if (!user) {
      setIsLoading(false);
      setMessage('User is not authenticated');
      return;
    }
  
    const authenticationDetails = new AuthenticationDetails({
      Username: user.getUsername(),
      Password: formData.currentPassword,
    });
  
    user.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        setFormData((prevState) => ({
          ...prevState,
          currentPassword: formData.currentPassword,
        }));
        setCurrentStep('newpassword');
        setIsLoading(false);
  
        toast.success('Current password is valid!'); 
      },
      onFailure: (error) => {
        setIsLoading(false);
        if (error.code === 'NotAuthorizedException') {
          setValidationErrors({ currentPassword: 'Wrong current password' });
          toast.error('Wrong current password!'); 
        } else {
          setValidationErrors({ currentPassword: 'Error occurred during authentication' });
          toast.error('Authentication error occurred!'); 
        }
        setMessage(error.message);
      },
    });
  };
  
  
  const handleChangePassword = (newPassword: string, confirmPassword: string) => {
    setIsLoading(true);
  
    const user = userPool.getCurrentUser();
    if (!user) {
      setIsLoading(false);
      setMessage('User is not authenticated');
      return;
    }
  
    const authenticationDetails = new AuthenticationDetails({
      Username: user.getUsername(),
      Password: formData.currentPassword,
    });
  
        user.authenticateUser(authenticationDetails, {
            onSuccess: (result) => {
              setFormData((prevState) => ({
                ...prevState,
                newPassword: newPassword,
                confirmPassword: confirmPassword,
              }));
        

        user.changePassword(formData.currentPassword, newPassword, (error, result) => {
          setIsLoading(false);
          if (error) {
            setMessage(error.message);
          } else {
            console.log('Change password success:', result);
            setMessage('Password has been changed successfully!');
            setFormData({
              currentPassword: '',
              newPassword: '',
              confirmPassword: '',
            });
            setValidationResults({
              currentPassword: '',
              newPassword: '',
              confirmPassword: '',
            });
            setCurrentStep('currentPassword'); 
          }
        });
      },
      onFailure: (error) => {
        setIsLoading(false);
        setMessage(error.message);
      },
    });
  };

  

  return (
    <>
      {currentStep === 'currentPassword' && <CurrentPassword onSubmit={handleFormSubmit} />}
      {currentStep === 'newpassword' && (
        <NewPassword onSubmit={handleChangePassword} onCancel={handleCancel} oldPassword={oldPassword} />
      )}
    </>
  );
};

export default PasswordManager;


